import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const ServicesCategoryShow = () => {
	const auth = useSelector(state => state.auth.user);
	const { categoryID } = useParams();

	const history = useHistory();
	const [title, setTitle] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [loading, setLoading] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة تصنيف خدمة جديد",
				breadcrumb: "تصنيفات الخدمات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/serviceCategories/${categoryID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setTitle(response?.data?.data?.name?.ar);
				setTitleEn(response?.data?.data?.name?.en);

				setLoading(false);
			})
			.catch(function (error) {
				console.log("error", error);
				setLoading(false);
			});
	};

	const handleSubmit = e => {
		e.preventDefault();

		if (!title?.trim() || !titleEn?.trim()) {
			toast.error("برجاء ملئ جميع الحقول!");
			return;
		}

		const name = {
			ar: title.trim(),
			en: titleEn.trim(),
		};

		setLoading(true);

		axios
			.put(
				`${process.env.REACT_APP_API_URL}/serviceCategories/${categoryID}`,
				{
					name,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/servicesCategories/index");
				toast.success("تم إضافة التصنيف بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				console.log("error", error);
				toast.error("خطأ، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="card">
					<div className="card-body">
						<div className="row">
							<div className="col-12 col-md-6">
								<div className="form-item">
									<label htmlFor="title"> العنوان بالعربية</label>
									<input
										type="text"
										id="title"
										value={title}
										onChange={e => setTitle(e.target.value)}
									/>
								</div>
							</div>
							<div className="col-12 col-md-6">
								<div className="form-item">
									<label htmlFor="title"> العنوان بالانجليزية</label>
									<input
										type="text"
										dir="ltr"
										id="title"
										value={titleEn}
										onChange={e => setTitleEn(e.target.value)}
									/>
								</div>
							</div>
							<div className="col-12 col-md-6">
								<div className="form-item mt-3">
									<button className="bt bt-success btn-block">ارسال</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default ServicesCategoryShow;
